import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdAccountBalance,
  MdArrowBackIos,
  MdAutoAwesome,
  MdCalendarToday,
  MdCampaign,
  MdChat,
  MdChatBubbleOutline,
  MdClose,
  MdFavoriteBorder,
  MdGroup,
  MdGroups,
  MdLanguage,
  MdMail,
  MdMailOutline,
  MdOutlineCampaign,
  MdOutlineShoppingBag,
  MdPerson,
  MdPersonAdd,
  MdPersonOutline,
  MdSearch,
  MdShoppingBag,
  MdShoppingCart,
  MdTaskAlt,
  MdRecordVoiceOver,
  MdLogin,
} from "react-icons/md";

import "../styles/App.css";
import { useLocation, useNavigate } from "react-router";
import { useParams } from "react-router-dom";
import { isEmpty } from "../functions/isEmpty";
import { useLanguage } from "../contexts/LanguageContext";

export default function Topnav({
  isMobile,
  user,
  cart,
  scrollToObject,
  language,
  setLanguage,
}) {
  let navigate = useNavigate();
  const location = useLocation();
  const [cart_count, setCart_count] = useState(0);

  const showProducts = () => {
    if (location.pathname != "" && location.pathname != "/") {
      navigate("/");
    } else {
      scrollToObject("products");
    }
  };

  useEffect(() => {
    setCart_count(cart.length);
  }, [cart]);
  useEffect(() => {
    const el = document.getElementById("topnav");
    if (!el) return;

    const onScroll = () => {
      if (window.scrollY > 100) {
        el.classList.add("whitebackground");
        // Safe-Area Top aus CSS holen
        const safeTop = getComputedStyle(document.documentElement)
          .getPropertyValue("--safe-top")
          .trim();
        // wenn Wert leer -> 0px
        el.style.top = safeTop || "0px";
      } else {
        el.classList.remove("whitebackground");
        // zurück auf Standard
        el.style.top = "0px";
      }
    };

    // initialer Zustand (falls Seite schon gescrolled geladen wird)
    onScroll();

    // passive Listener hilft iOS beim Repaint während inertial scroll
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <div className="app_topnav" id="topnav">
        <div className="app_topnav_wrapper">
          <div className="app_topnav_left">
            {isMobile && (
              <img
                src="https://starthome.ai/starthome_logo_v2_small.png"
                className="app_topnav_middle_logo_small"
                onClick={() => navigate("/")}
              />
            )}

            {!isMobile && (
              <div
                className="app_topnav_right_navlink"
                onClick={() => navigate("/login")}>
                <>{language == "English" ? "Login" : "Einloggen"}</>
              </div>
            )}

            {!isMobile && (
              <div
                className="app_topnav_right_navlink"
                onClick={() =>
                  language == "English"
                    ? setLanguage("Deutsch")
                    : setLanguage("English")
                }>
                <>{language == "English" ? "In Deutsch" : "In English"}</>
              </div>
            )}
          </div>

          <div className="app_topnav_middle">
            {!isMobile && (
              <img
                src="https://starthome.ai/starthome_logo_v2.png"
                className="app_topnav_middle_logo"
                onClick={() => navigate("/")}
              />
            )}

            <div className="app_topnav_middle_sub">
              {/*
            language == "English" ? "A.I. for your home" : "K.I. für zu Hause"
            */}
            </div>
          </div>

          <div className="app_topnav_right">
            {isMobile && (
              <div
                className="app_topnav_right_navlink_mobile"
                onClick={() => navigate("/login")}>
                <LoginIcon /> {language == "English" ? "Login" : "Einloggen"}{" "}
              </div>
            )}

            {isMobile && (
              <div
                className="app_topnav_right_navlink_mobile"
                onClick={() =>
                  language == "English"
                    ? setLanguage("Deutsch")
                    : setLanguage("English")
                }>
                <>
                  <LanguageIcon />{" "}
                  {language == "English" ? "Deutsch" : "English"}
                </>
              </div>
            )}

            {/*
           <div
            className="app_topnav_right_navlink"
            onClick={() => showProducts()}>
            Products
          </div>
          */}

            <div
              className="app_topnav_right_navlink"
              onClick={() => navigate("/cart")}>
              <CartIcon />
              {cart_count > 0 && (
                <div className="app_topnav_right_navlink_cartcount">
                  {cart_count}
                </div>
              )}
              {!isMobile && <>{language == "Deutsch" ? "Warenkorb" : "Cart"}</>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const LanguageIcon = styled(MdLanguage)`
  font-size: 25px;
  color: #777777ff;
`;

const CartIcon = styled(MdOutlineShoppingBag)`
  font-size: 33px;
  color: #777777ff;
  margin-bottom: 5px;
`;

const VoiceCommand = styled(MdRecordVoiceOver)`
  font-size: 25px;
  color: #777777ff;
`;

const LoginIcon = styled(MdPerson)`
  font-size: 25px;
  color: #777777ff;
`;

const PersonIcon = styled(MdPersonAdd)`
  font-size: 33px;
  color: #717171;
`;

const PersonIconActive = styled(MdPersonAdd)`
  font-size: 33px;
  color: #950178;
`;

const GroupIcon = styled(MdGroups)`
  font-size: 36px;
  color: #717171;
`;

const GroupIconActive = styled(MdGroups)`
  font-size: 36px;
  color: #950178;
`;

const SearchIcon = styled(MdSearch)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -2px;
`;

const SearchIconActive = styled(MdSearch)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const ChatsIcon = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #717171;
`;

const ChatsIconActive = styled(MdChatBubbleOutline)`
  font-size: 26px;
  color: #2d81e0;
`;

const TasksIcon = styled(MdTaskAlt)`
  font-size: 26px;
  color: #717171;
`;

const TaskIconActive = styled(MdTaskAlt)`
  font-size: 26px;
  color: #2d81e0;
`;

const AutoIcon = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #717171;
`;

const AutoIconActive = styled(MdAutoAwesome)`
  font-size: 26px;
  color: #2d81e0;
`;

const MailIcon = styled(MdMailOutline)`
  font-size: 31px;
  color: #717171;
  margin-bottom: -2px;
`;

const MailIconActive = styled(MdMail)`
  font-size: 31px;
  color: #ff29a7;
  margin-bottom: -2px;
`;

const BankIcon = styled(MdAccountBalance)`
  font-size: 27px;
  color: #717171;
  margin-bottom: -1px;
`;

const BankIconActive = styled(MdAccountBalance)`
  font-size: 27px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CampaignIcon = styled(MdCampaign)`
  font-size: 32px;
  color: #717171;
  margin-bottom: -1px;
`;

const CampaingIconActive = styled(MdCampaign)`
  font-size: 32px;
  color: #ff29a7;
  margin-bottom: -1px;
`;

const CalendarIcon = styled(MdCalendarToday)`
  font-size: 25px;
  color: #717171;
  margin-bottom: 2px;
`;

const CalendarIconActive = styled(MdCalendarToday)`
  font-size: 25px;
  color: #ff29a7;
  margin-bottom: 2px;
`;
